export const GET_OPS_ADMIN_RESIT_ORGANIZATION = 'organisations';
export const GET_OPS_ADMIN_RESIT_ACTIONS = 'user-modules';
export const GET_COORDINATOR_BY_SCHOOL = 'admin/organisations';
export const POST_OPP_ADMIN_SEARCH_CANDIDATE = 'admin/resit/candidate';
export const POST_OOP_ADMIN_RESIT_REGISTER_DETAIL = 'admin/resit/registrations/search';
export const POST_OOP_ADMIN_DOWNLOAD_RESIT_REGISTER_DETAIL = 'admin/resit/registrations/report';
export const GET_OOP_ADMIN_RESIT_REGISTER_INDIVIDUAL_DETAIL = 'admin/resit/registration';
export const GET_EXAM_LEVEL_OPTIONS = 'exam-level';
export const GET_SCHOOL_OPTIONS = 'school';
export const GET_PAYMENT_MODE_OPTIONS = 'payment-mode';
